export default __webpack_public_path__ + "static/media/4.765aa790.jpg";